// @flow

import { path, pathOr } from 'ramda'

import { getDeviceType } from '@alphaott/smart-tv-platforms'

export const isFeatureEnabled = (settings: Object, featureKey: string): boolean => {
  const platformType = getDeviceType().toLowerCase()
  const featureSettings = path([featureKey], settings)

  const globallyEnabled = pathOr(true, ['enabled'], featureSettings)
  const platformEnabled = pathOr(true, ['platform', platformType, 'enabled'], featureSettings)

  return globallyEnabled && platformEnabled
}
